import AbstractPexList from './Tc.Module.AbstractPexList';
import { IncidentListRenderer, showInfoDialog } from './IncidentListRenderer';
import { TableHeader } from './TableHeader';
import { IncidentType, ICustomerListData, IHeadingInfo } from './model';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import { parse as jsonToCSV } from 'json2csv';
import SdxModal from 'lib/generic/SDXModalDialog';

export default class PexIncidentList extends AbstractPexList {
	protected searchablesProps! : Set<string>;
	private incidentListRenderer! : IncidentListRenderer;
	private tableHeaders! : TableHeader;
	private displayedTypes! : IncidentType[];

	public on(callback : Hook) {
		this.searchablesProps = new Set();
		['customerName', 'location', 'title', 'date', 'scn']
			.forEach(searchProp => this.searchablesProps.add(searchProp));
		this.displayedTypes = ((this.$ctx.data('incident-types').split(',') as IncidentType[]) || [])
			.map(incidentType => incidentType.toUpperCase() as IncidentType);

		this.dataUrl = `${this.$ctx.data('ajax-url')}.outages.json`;

		super.on(callback);
	}

	public async init() {
		await super.init();
		this.displayIncidentInfo();
	}

	protected render() {
		const $placeholdeDiv = this.$ctx.find('.table-holder');
		this.incidentListRenderer = new IncidentListRenderer(
			$placeholdeDiv.find('thead').get(0),
			this.data,
			this.labels,
			this.$ctx.data('ajax-url'),
			this.displayedTypes,
		);
		const headings = this.createHeadings();

		this.tableHeaders = new TableHeader(
			$placeholdeDiv.find('tbody').get(0),
			headings,
			{ sortAction: this.onSort.bind(this) },
			this.displayedTypes,
		);


		this.tableHeaders.render();
		this.incidentListRenderer.render();
		this.setupFadeoutEffect();
	}

	protected update() {
		this.incidentListRenderer.render();
		this.setupFadeoutEffect();
	}

	protected async fetchData() {
		return super.fetchData()
		.then((data : ICustomerListData[]) => {
			return data.filter(elem => this.displayedTypes.includes(elem.type));
		});
	}
	protected exportToCSV() {
		const dataToExport = this.data.filter(item => item.display);
		const config = {
			delimiter: ',',
			eol: '\n',
			fields: [
				{
					label: this.labels.customerListNr,
					value: 'scn',
				},
				{
					label: this.labels.customerName,
					value: 'customerName',
				},
				{
					label: this.labels.location,
					value: 'location',
				},
				{
					label: this.labels.title,
					value: 'title',
				},
				{
					label: this.labels.datum,
					value: 'date',
				},
			],
			header: true,
			includeEmptyRows: true,
		};
		const csv = jsonToCSV(dataToExport, config);

		const blob = new Blob([csv], { type: 'text/csv;encoding:utf-8' });
		const a = document.createElement('a');
		const url = window.URL.createObjectURL(blob);
		a.href = url;
		a.download = 'PexIncidentList.csv';
		document.body.appendChild(a);
		a.click();
		a.remove();
	}

	private createHeadings() : IHeadingInfo[] {
		return [
			{
				sort: true,
				sortName: 'title',
				title: this.labels.title,
			},
			{
				sort: true,
				sortName: 'location',
				title: this.labels.location,
			},
			{
				sort: true,
				sortName: 'customerName',
				title: this.labels.customerName,
			},
			{
				sort: true,
				sortName: 'scn',
				title: this.labels.customerListNr,
			},
			{
				sort: true,
				sortName: 'creationDateTamestamp',
				title: this.labels.datum,
			},
			{
				sort: false,
				sortName: '',
				title: '',
			},
		];
	}

	private displayIncidentInfo() {
		const queryParams = new URLSearchParams(window.location.search);
		if (queryParams.has('sit')) {
			const sitID = parseInt(queryParams.get('sit')!, 10);
			const status = queryParams.has('incidentStatus') ?
				(queryParams.get('incidentStatus')!.toLowerCase() === 'end' ? 'closed' : 'open') : '';

			const incident = this.data.find(item => item.id === sitID && (status ? item.status === status : true));

			if (incident) {
				showInfoDialog(
					sitID,
					incident.scn,
					incident.customerName,
					this.$ctx.data('ajax-url'),
					this.labels,
				);
			} else {
				SdxModal.show({
					buttons: [{
						thin: true,
						title: this.labels.closeBtnLabel,
						type : 'close',
					}],
					notification: 'alert',
					text: this.labels.noSearchResultMessage,
				});
			}
		}
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/Tc.Module.PexIncidentList.ts